import {
  ApolloCache,
  ApolloError,
  DefaultContext,
  MutationUpdaterFunction,
  useMutation,
} from '@apollo/client';
import { UPDATE_SALES_ORDER } from 'graphql/mutations/updateSalesOrder';
import {
  Mutation,
  MutationUpdateSalesOrderArgs,
} from 'types/generatedSchemaTypes';

type UpdateSalesOrderProps = {
  customUpdate?: MutationUpdaterFunction<
    Mutation,
    MutationUpdateSalesOrderArgs,
    DefaultContext,
    ApolloCache<any>
  >;
  customOnCompleted?: (data: Mutation) => void;
  customOnError?: (error: ApolloError) => void;
};

const useUpdateSalesOrder = ({
  customUpdate,
  customOnCompleted,
  customOnError,
}: UpdateSalesOrderProps) => {
  const [updateSalesOrder, { loading }] = useMutation<
    Mutation,
    MutationUpdateSalesOrderArgs
  >(UPDATE_SALES_ORDER, {
    update: customUpdate,
    onCompleted: customOnCompleted,
    onError: customOnError,
  });

  return {
    updateSalesOrder,
    loading,
  };
};

export default useUpdateSalesOrder;
